import { makeStyles } from 'tss-react/mui';
import React from 'react';
import clsx from 'clsx';
import { MAIN_THEME } from '@styles';
import { IFormFieldInputBaseProps } from '@components/form-fields';

interface IHeaderContainerProps extends IFormFieldInputBaseProps {
  background: string;
  height: number;
  children?: React.ReactNode;
}

const useStyles = makeStyles<{ background: string; height: number }>()(
  (theme, { background, height }) => ({
    header: {
      background: background,
      height: height,
      minHeight: height,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'normal',
      overflow: 'hidden',
      fontFamily: MAIN_THEME.font.medium,
    },
  })
);

const HeaderContainer: React.FC<IHeaderContainerProps> = ({
  children,
  className,
  style,
  background,
  height,
}) => {
  const { classes } = useStyles({ background, height });

  return (
    <header className={clsx(classes.header, className)} style={style}>
      {children}
    </header>
  );
};

export default HeaderContainer;
